import React, {useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import "./App.css";
import VerticalNavbar from "./components/VerticalNavbar";
import AboutSection from "./components/AboutSection";
import "./components/ProjectCard.css";
import SkillPopover from "./components/SkillPopover";
import Timeline from "./components/Timeline";
import ProjectPopover from "./components/ProjectPopover";
import Impressum from "./components/Impressum";
import Datenschutz from "./components/Datenschutz";
import infos from "./infos.json";

// Skill tags for the skills section
const skillTags = infos.skills;

// Timeline events
const timelineEvents = infos.timeline;

function SkillsSection({ selectedSkill, setSelectedSkill, aboutText }) {
  return (
    <section id="skills" className="skills">
      <div className="container skills-flex">
        <div className="skills-about">
          <h2>Get to know me!</h2>
          <div className="skills-about-text">
            <p>
              {aboutText}
            </p>
          </div>
        </div>
        <div className="skills-tags">
          <h2>My Skills</h2>
          <div className="skills-tag-grid">
            {skillTags.map((skill) => (
              <span className="skill-tag" key={skill} onClick={() => setSelectedSkill(skill)}>{skill}</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function TimelineSection({ onProjectClick }) {
  return (
    <section id="timeline" className="timeline-section">
      <div className="container">
        <h2>My Journey</h2>
        <Timeline events={timelineEvents} onProjectClick={onProjectClick} />
      </div>
    </section>
  );
}

function ContactSection() {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [formErrors, setFormErrors] = useState({});

  const validate = () => {
    const errors = {};
    if (!formData.name.trim()) {
      errors.name = "Please enter your name.";
    } else if (formData.name.length < 2) {
      errors.name = "Name must be at least 2 characters.";
    }
    if (!formData.email.trim()) {
      errors.email = "Please enter your email address.";
    } else if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(formData.email)) {
      errors.email = "Please enter a valid email address.";
    }
    if (!formData.message.trim()) {
      errors.message = "Please enter your message.";
    }
    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validate();
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      const subject = `New message from ${formData.name}`;
      const body = `${formData.message}`;
      const mailtoLink = `mailto:${infos.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      window.location.href = mailtoLink;
      setFormData({ name: "", email: "", message: "" });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <section id="contact" className="contact">
      <div className="container">
        <h2>Contact</h2>
        <form onSubmit={handleSubmit} noValidate>
          <label htmlFor="name">Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required  
            minLength={2}
            maxLength={50}
            pattern="^[A-Za-zÀ-ÿ ,.'-]+$"
            autoComplete="name"
            placeholder="Your name"
            aria-invalid={!!formErrors.name}
            aria-describedby="name-error"
          />
          {formErrors.name && (
            <span className="form-error" id="name-error">{formErrors.name}</span>
          )}

          <label htmlFor="email">Your Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            autoComplete="email"
            placeholder="you@example.com"
            pattern="^[^@\s]+@[^@\s]+\.[^@\s]+$"
            aria-invalid={!!formErrors.email}
            aria-describedby="email-error"
          />
          {formErrors.email && (
            <span className="form-error" id="email-error">{formErrors.email}</span>
          )}

          <label htmlFor="message">Message</label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
            minLength={0}
            maxLength={1000}
            placeholder="Your message"
            aria-invalid={!!formErrors.message}
            aria-describedby="message-error"
          ></textarea>
          {formErrors.message && (
            <span className="form-error" id="message-error">{formErrors.message}</span>
          )}

          <button type="submit" className="submit-button">
            Send
          </button>
        </form>
      </div>
    </section>
  );
}

function Home() {
  const [selectedSkill, setSelectedSkill] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);

  return (
    <div className="App">
      <VerticalNavbar name={infos.name} />
      <AboutSection about={infos.about} />
      <SkillsSection selectedSkill={selectedSkill} setSelectedSkill={setSelectedSkill} aboutText={infos.about.text} />
      <TimelineSection onProjectClick={setSelectedProject} />
      <ContactSection />
      <SkillPopover skill={selectedSkill} onClose={() => setSelectedSkill(null)} />
      <ProjectPopover project={selectedProject} onClose={() => setSelectedProject(null)} />
      <footer className="footer">
        <div className="container">
          <Link to="/impressum">Impressum</Link>
          <p>&copy; 2025 {infos.name}. All rights reserved.</p>
          <Link to="/datenschutz">Datenschutz</Link>
        </div>
      </footer>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
      </Routes>
    </Router>
  );
}

export default App;
